<template>
    <div class="status-menu">
        <context-menu v-if="value != null" ref="ctxMenu">
            <li @click="handleOpenOverride">Override</li>
            <li>
                <span>Excuse</span>
                <ul>
                    <li @click="handleExcuse(5)">Class Cancelled</li>
                    <li @click="handleExcuse(4)">Travel</li>
                    <li @click="handleExcuse(8)">Hybrid</li>
                    <li @click="handleExcuse(7)">Not Active</li>
                </ul>
            </li>
        </context-menu>
        <modal v-if="value != null" v-model="showOverride" size="small">
            <attendance-override v-model="value"/>
        </modal>
    </div>
</template>

<script>
import ContextMenu from 'vue-context-menu'
import AttendanceOverride from '../pages/Student/AttendanceOverride.vue'

export default {
    name: 'status-menu',
    components: {
        ContextMenu,
        AttendanceOverride
    },
    props: {
        value: {
            type: Object,
            default: function() {
                return { status: 7 }
            }
        }
    },
    data() {
        return {
            showOverride: false
        }
    },
    computed: {},
    methods: {
        open() {
            this.$refs.ctxMenu.open()
        },
        handleOpenOverride() {
            this.showOverride = true
        },
        handleExcuse(value) {
            this.value.lock = 1
            this.value.overrides = [{ old_status: this.value.status }]
            this.value.status = value

            this.value.$update()
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.status-menu
    .ctx-menu, .ctx-menu ul
        padding: 5px 0px
        margin: 2px 0 0
        font-size: 14px
        color: $text-dark-grey
        background-color: $white
        border: 1px solid rgba(0, 0, 0, 0.1)
        border-radius: 6px
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.1)

        li
            padding: 5px 10px
            display: block
            text-decoration: none
            color: $text-dark-grey
            font-size: 16px
            cursor: pointer
            position: relative

            &:hover, &.router-link-active, &:hover
                background: $dark-blue
                color: $white

            ul
                display: none
                position: absolute
                top: -5px
                left: 100%
                width: auto
                width: 100%
                margin-left: -15px

            &:hover ul
                display: block
</style>
